module.exports = __webpack_public_path__ + "img/wool_lg.8379974.webp";